var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoise(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_393_5142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.59347 22.9397H7.53662C8.30752 22.9397 8.87731 22.2303 8.72143 21.4753C8.72035 21.4701 8.71927 21.4648 8.71819 21.4596L8.10609 18.4443C7.9569 17.7105 7.98754 16.9579 8.18735 16.2486C8.31947 15.7785 7.95951 15.3136 7.47116 15.3136H5.65888C5.17053 15.3136 4.81058 15.7785 4.94269 16.2486C5.14246 16.9579 5.17314 17.7105 5.02395 18.4443L4.41185 21.4596C4.41077 21.4648 4.40969 21.4701 4.40861 21.4753C4.25274 22.2303 4.82257 22.9397 5.59347 22.9397Z",
    fill: "url(#paint0_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59347 22.9397H7.53662C8.30752 22.9397 8.87731 22.2303 8.72143 21.4753C8.72035 21.4701 8.71927 21.4648 8.71819 21.4596L8.10609 18.4443C7.9569 17.7105 7.98754 16.9579 8.18735 16.2486C8.31947 15.7785 7.95951 15.3136 7.47116 15.3136H5.65888C5.17053 15.3136 4.81058 15.7785 4.94269 16.2486C5.14246 16.9579 5.17314 17.7105 5.02395 18.4443L4.41185 21.4596C4.41077 21.4648 4.40969 21.4701 4.40861 21.4753C4.25274 22.2303 4.82257 22.9397 5.59347 22.9397Z",
    fill: "url(#paint1_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.40863 21.4753C4.40971 21.4701 4.41078 21.4648 4.41186 21.4596L4.56055 20.7271H8.56943L8.71812 21.4596C8.7192 21.4649 8.72023 21.4701 8.72135 21.4754C8.87728 22.2303 8.30744 22.9397 7.53658 22.9397H5.59344C4.82254 22.9397 4.2527 22.2303 4.40863 21.4753Z",
    fill: "url(#paint2_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53512 22.9397H5.72266V15.3136H7.46967C7.95801 15.3136 8.31797 15.7785 8.18586 16.2486C7.98609 16.9579 7.95541 17.7105 8.10464 18.4443L8.7167 21.4596C8.71778 21.4649 8.71881 21.4701 8.71993 21.4754C8.87581 22.2303 8.30602 22.9397 7.53512 22.9397Z",
    fill: "url(#paint3_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.62109 8.30298H2.21534C1.26798 8.30298 0.5 9.88194 0.5 11.8298C0.5 13.7776 1.26798 15.3565 2.21534 15.3565H4.62109C5.56845 15.3565 6.33643 13.7775 6.33643 11.8298C6.33643 9.88198 5.5684 8.30298 4.62109 8.30298Z",
    fill: "url(#paint4_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.70326 9.67603H1.64728C1.53574 9.67603 1.44531 9.5856 1.44531 9.47406C1.44531 9.36252 1.53574 9.27209 1.64728 9.27209H2.70326C2.8148 9.27209 2.90523 9.36252 2.90523 9.47406C2.90523 9.5856 2.8148 9.67603 2.70326 9.67603Z",
    fill: "url(#paint5_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.49618 10.6183H1.44025C1.32871 10.6183 1.23828 10.5279 1.23828 10.4163C1.23828 10.3048 1.32871 10.2144 1.44025 10.2144H2.49623C2.60777 10.2144 2.6982 10.3048 2.6982 10.4163C2.69815 10.5279 2.60772 10.6183 2.49618 10.6183Z",
    fill: "url(#paint6_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.36732 11.5606H1.31134C1.1998 11.5606 1.10938 11.4701 1.10938 11.3586C1.10938 11.247 1.1998 11.1566 1.31134 11.1566H2.36732C2.47886 11.1566 2.56929 11.247 2.56929 11.3586C2.56929 11.4702 2.47886 11.5606 2.36732 11.5606Z",
    fill: "url(#paint7_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.36732 12.5029H1.31134C1.1998 12.5029 1.10938 12.4125 1.10938 12.301C1.10938 12.1894 1.1998 12.099 1.31134 12.099H2.36732C2.47886 12.099 2.56929 12.1894 2.56929 12.301C2.56929 12.4125 2.47886 12.5029 2.36732 12.5029Z",
    fill: "url(#paint8_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.49618 13.4452H1.44025C1.32871 13.4452 1.23828 13.3548 1.23828 13.2432C1.23828 13.1317 1.32871 13.0413 1.44025 13.0413H2.49623C2.60777 13.0413 2.6982 13.1317 2.6982 13.2432C2.69815 13.3548 2.60772 13.4452 2.49618 13.4452Z",
    fill: "url(#paint9_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.70326 14.3875H1.64728C1.53574 14.3875 1.44531 14.297 1.44531 14.1855C1.44531 14.0739 1.53574 13.9835 1.64728 13.9835H2.70326C2.8148 13.9835 2.90523 14.0739 2.90523 14.1855C2.90523 14.297 2.8148 14.3875 2.70326 14.3875Z",
    fill: "url(#paint10_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.62159 8.30298C3.67423 8.30298 2.90625 9.88198 2.90625 11.8298C2.90625 13.7775 3.67423 15.3565 4.62159 15.3565C5.56895 15.3565 6.33693 13.7775 6.33693 11.8298C6.33693 9.88198 5.5689 8.30298 4.62159 8.30298Z",
    fill: "url(#paint11_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.62159 8.30298C3.67423 8.30298 2.90625 9.88198 2.90625 11.8298C2.90625 13.7775 3.67423 15.3565 4.62159 15.3565C5.56895 15.3565 6.33693 13.7775 6.33693 11.8298C6.33693 9.88198 5.5689 8.30298 4.62159 8.30298Z",
    fill: "url(#paint12_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.90625 11.8297C2.90625 13.7775 3.67423 15.3565 4.62159 15.3565C5.56895 15.3565 6.33693 13.7775 6.33693 11.8297C6.33693 11.5384 6.31964 11.2555 6.28725 10.9847H2.95593C2.92354 11.2555 2.90625 11.5384 2.90625 11.8297Z",
    fill: "url(#paint13_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16249 11.6643H0.501932C0.500719 11.7191 0.5 11.7743 0.5 11.8298C0.5 13.7775 1.26798 15.3565 2.21534 15.3565H4.62109C5.2982 15.3565 5.88362 14.5498 6.16254 13.3783L6.16249 11.6643Z",
    fill: "url(#paint14_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6851 2.20801V21.4515C16.6851 21.4515 15.0161 19.0553 10.1302 17.5901C9.1393 17.2931 8.01571 17.0339 6.74725 16.8413C6.09521 16.7422 5.48095 16.5752 4.91646 16.3513C4.29313 16.1041 3.81803 15.7101 3.57541 15.2411C3.23324 14.5796 2.80859 13.4353 2.80859 11.8297C2.80859 10.4928 3.12799 9.26236 3.6631 8.28513C3.69441 8.22812 3.72639 8.17202 3.75905 8.11676C3.90873 7.86367 4.16182 7.64625 4.48831 7.49302C5.16529 7.17524 5.92617 6.94322 6.74725 6.81825C8.01571 6.62558 9.1393 6.36643 10.1302 6.06945C15.0161 4.60419 16.6851 2.20801 16.6851 2.20801Z",
    fill: "url(#paint15_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83203 6.80456V16.8549C14.2871 18.0118 16.6834 21.4516 16.6834 21.4516V2.20789C16.6834 2.20789 14.2871 5.64764 6.83203 6.80456Z",
    fill: "url(#paint16_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.96312 10.2506C2.86304 10.7525 2.80859 11.282 2.80859 11.8297C2.80859 13.4353 3.23329 14.5796 3.57541 15.241C3.81803 15.7101 4.29313 16.1041 4.91646 16.3513C5.48095 16.5752 6.09521 16.7422 6.74725 16.8412C8.01571 17.0339 9.1393 17.2931 10.1302 17.59C15.0161 19.0553 16.6851 21.4514 16.6851 21.4514V10.2506H2.96312Z",
    fill: "url(#paint17_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2652 22.599C21.158 22.599 23.5031 17.7774 23.5031 11.8297C23.5031 5.88201 21.158 1.06042 18.2652 1.06042C15.3724 1.06042 13.0273 5.88201 13.0273 11.8297C13.0273 17.7774 15.3724 22.599 18.2652 22.599Z",
    fill: "url(#paint18_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2663 1.06042C17.2243 1.06042 16.2534 1.68614 15.4375 2.76458V20.8949C16.2534 21.9733 17.2243 22.599 18.2663 22.599C21.1591 22.599 23.5042 17.7774 23.5042 11.8297C23.5042 5.88202 21.1591 1.06042 18.2663 1.06042Z",
    fill: "url(#paint19_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6531 20.6478C20.8066 20.6478 22.5523 16.6998 22.5523 11.8297C22.5523 6.9596 20.8066 3.0116 18.6531 3.0116C16.4996 3.0116 14.7539 6.9596 14.7539 11.8297C14.7539 16.6998 16.4996 20.6478 18.6531 20.6478Z",
    fill: "url(#paint20_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6531 20.6478C20.8066 20.6478 22.5523 16.6998 22.5523 11.8297C22.5523 6.9596 20.8066 3.0116 18.6531 3.0116C16.4996 3.0116 14.7539 6.9596 14.7539 11.8297C14.7539 16.6998 16.4996 20.6478 18.6531 20.6478Z",
    fill: "url(#paint21_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0352 12.4487C13.1912 18.1084 15.4725 22.5991 18.2642 22.5991C21.056 22.5991 23.3373 18.1084 23.4933 12.4487H13.0352Z",
    fill: "url(#paint22_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5496 12.0918L21.162 10.7042L14.9336 14.4876V14.4895C15.4325 18.0596 16.9085 20.6479 18.6521 20.6479C20.7669 20.6478 22.4882 16.8406 22.5496 12.0918Z",
    fill: "url(#paint23_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6167 11.8298C21.6167 12.3395 21.3915 12.703 21.2103 12.9128C21.0813 13.0617 20.8295 13.1871 20.4989 13.2654C20.1995 13.3366 19.8739 13.3898 19.528 13.421C18.8549 13.4824 18.2591 13.5643 17.7335 13.659C16.3659 13.9047 15.4733 14.2323 14.9354 14.4877C14.9354 14.4877 14.6289 13.7418 14.6289 11.8298C14.6289 9.91776 14.9354 9.17188 14.9354 9.17188C15.4733 9.42726 16.3659 9.75483 17.7335 10.0005C18.2591 10.0952 18.8549 10.1771 19.528 10.2385C19.9635 10.2779 20.3668 10.3516 20.7261 10.453C20.8991 10.5016 21.0332 10.5702 21.1131 10.6505C21.13 10.6684 21.1473 10.6864 21.1637 10.7042C21.4478 11.0144 21.6167 11.4054 21.6167 11.8298Z",
    fill: "url(#paint24_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6167 11.8298C21.6167 12.3395 21.3915 12.703 21.2103 12.9128C21.0813 13.0617 20.8295 13.1871 20.4989 13.2654C20.1995 13.3366 19.8739 13.3898 19.528 13.421C18.8549 13.4824 18.2591 13.5643 17.7335 13.659C16.3659 13.9047 15.4733 14.2323 14.9354 14.4877C14.9354 14.4877 14.6289 13.7418 14.6289 11.8298C14.6289 9.91776 14.9354 9.17188 14.9354 9.17188C15.4733 9.42726 16.3659 9.75483 17.7335 10.0005C18.2591 10.0952 18.8549 10.1771 19.528 10.2385C19.9635 10.2779 20.3668 10.3516 20.7261 10.453C20.8991 10.5016 21.0332 10.5702 21.1131 10.6505C21.13 10.6684 21.1473 10.6864 21.1637 10.7042C21.4478 11.0144 21.6167 11.4054 21.6167 11.8298Z",
    fill: "url(#paint25_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6167 11.8298C21.6167 12.3395 21.3915 12.703 21.2103 12.9128C21.0813 13.0617 20.8295 13.1871 20.4989 13.2654C20.1995 13.3366 19.8739 13.3898 19.528 13.421C18.8549 13.4824 18.2591 13.5643 17.7335 13.659C16.3659 13.9047 15.4733 14.2323 14.9354 14.4877C14.9354 14.4877 14.6289 13.7418 14.6289 11.8298C14.6289 9.91776 14.9354 9.17188 14.9354 9.17188C15.4733 9.42726 16.3659 9.75483 17.7335 10.0005C18.2591 10.0952 18.8549 10.1771 19.528 10.2385C19.9635 10.2779 20.3668 10.3516 20.7261 10.453C20.8991 10.5016 21.0332 10.5702 21.1131 10.6505C21.13 10.6684 21.1473 10.6864 21.1637 10.7042C21.4478 11.0144 21.6167 11.4054 21.6167 11.8298Z",
    fill: "url(#paint26_linear_393_5142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.051 10.6508C20.0336 10.6683 20.0167 10.6861 20.0001 10.7042C19.7163 11.0146 19.5469 11.4052 19.5469 11.8298C19.5469 12.3396 19.7721 12.7029 19.9536 12.913C20.0712 13.0491 20.2927 13.1649 20.5822 13.2438C20.8717 13.1649 21.0932 13.0491 21.2108 12.913C21.3923 12.7029 21.6175 12.3396 21.6175 11.8298C21.6175 11.4052 21.4481 11.0145 21.1643 10.7042C21.1477 10.6861 21.1307 10.6683 21.1134 10.6508C21.034 10.5704 20.8998 10.5014 20.7266 10.4527C20.6793 10.4394 20.6311 10.4267 20.5822 10.4143C20.5333 10.4267 20.4851 10.4394 20.4378 10.4527C20.2646 10.5014 20.1304 10.5704 20.051 10.6508Z",
    fill: "url(#paint27_linear_393_5142)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_393_5142",
    x1: 5.62313,
    y1: 19.1234,
    x2: 7.03974,
    y2: 19.1234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_393_5142",
    x1: 6.75987,
    y1: 19.1285,
    x2: 7.36798,
    y2: 17.4501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_393_5142",
    x1: 3.60984,
    y1: 19.6376,
    x2: 8.16254,
    y2: 22.6728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_393_5142",
    x1: 6.93998,
    y1: 19.1274,
    x2: 8.37323,
    y2: 19.1443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_393_5142",
    x1: 3.41821,
    y1: 9.42432,
    x2: 3.41821,
    y2: 14.3828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_393_5142",
    x1: 2.17529,
    y1: 9.66381,
    x2: 2.17529,
    y2: 9.32021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_393_5142",
    x1: 1.96822,
    y1: 10.6061,
    x2: 1.96822,
    y2: 10.2625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_393_5142",
    x1: 1.83931,
    y1: 11.5483,
    x2: 1.83931,
    y2: 11.2047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_393_5142",
    x1: 1.83931,
    y1: 12.4907,
    x2: 1.83931,
    y2: 12.1471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_393_5142",
    x1: 1.96822,
    y1: 13.4329,
    x2: 1.96822,
    y2: 13.0894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_393_5142",
    x1: 2.17529,
    y1: 14.3752,
    x2: 2.17529,
    y2: 14.0316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_393_5142",
    x1: -0.970597,
    y1: 6.47057,
    x2: 3.87652,
    y2: 11.1157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_393_5142",
    x1: 1.80328,
    y1: 11.0517,
    x2: 4.79602,
    y2: 11.8779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_393_5142",
    x1: 4.62159,
    y1: 12.3803,
    x2: 4.62159,
    y2: 15.1527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_393_5142",
    x1: 3.33125,
    y1: 12.8393,
    x2: 3.33125,
    y2: 15.1365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_393_5142",
    x1: 10.419,
    y1: 8.96448,
    x2: 10.0359,
    y2: 13.2334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_393_5142",
    x1: 9.491,
    y1: 10.9603,
    x2: 14.4714,
    y2: 11.5624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2153,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4291,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6424,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8543,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_393_5142",
    x1: 10.5439,
    y1: 13.2339,
    x2: 9.33983,
    y2: 17.6123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2153,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4291,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6424,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8543,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_393_5142",
    x1: 12.3265,
    y1: 11.8297,
    x2: 19.006,
    y2: 11.8297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_393_5142",
    x1: 16.8709,
    y1: 11.8298,
    x2: 23.652,
    y2: 11.8298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2153,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4291,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6424,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8543,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_393_5142",
    x1: 9.42478,
    y1: 9.78186,
    x2: 24.114,
    y2: 13.0415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2153,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4291,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6424,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8543,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_393_5142",
    x1: 21.8777,
    y1: 11.8297,
    x2: 14.3249,
    y2: 11.8297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2153,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4291,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6424,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8543,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_393_5142",
    x1: 19.2209,
    y1: 16.3415,
    x2: 22.5012,
    y2: 20.7978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2153,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4291,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6424,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8543,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_393_5142",
    x1: 19.7808,
    y1: 16.323,
    x2: 18.3944,
    y2: 13.2338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2153,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4291,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6424,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8543,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_393_5142",
    x1: 18.1228,
    y1: 10.7934,
    x2: 18.1228,
    y2: 12.9555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_393_5142",
    x1: 17.3684,
    y1: 11.5201,
    x2: 14.3583,
    y2: 11.9032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_393_5142",
    x1: 18.0624,
    y1: 12.0219,
    x2: 18.33,
    y2: 13.5057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_393_5142",
    x1: 17.7381,
    y1: 9.14028,
    x2: 22.0982,
    y2: 13.2633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_393_5142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoise);
export default __webpack_public_path__ + "static/media/noise.ba2f91365fe348492fd664a6a682f6e5.svg";
export { ForwardRef as ReactComponent };